'use strict';

import template from './location_confirmation_modal.html';
import settingsErrors from '../../modules/settings/settings';

export default {
  bindings: {
    onSuccess: '&',
    name: '@',
    type: '@',
  },
  template: template,
  controller: function($rootScope, $scope, $http, $timeout, $window,  utils, userModel, settings, locationConfirmationService) {
    'ngInject';

    const NOTIFICATION_DELAY = 15000;

    this.SETTINGS_ERRORS = settingsErrors.SETTINGS_ERRORS;

    try {
      var locationInitialId = '';
      if (locationConfirmationService.response
        && locationConfirmationService.response.location
        && locationConfirmationService.response.location.placeId) {
        locationInitialId = locationConfirmationService.response.location.placeId;
      }

      this.locationView = true;
      this.homeView = false;
      // remove this variable, inline text
      this.placeHolder = 'Enter your current location';

      // TODO: should redo this to be passed as parameters instead
      this.HOME = 'home';
      this.TRAVEL = 'trip_yes';

      this.YES = 'trip_yes';
      this.NO = 'trip_no';

      this.AUTOTRIP = 'AUTOTRIP';
      this.LOCATION_CONFIRMATION = 'LOCATION_CONFIRMATION';

      this.submitValue = [];

      if (this.type == this.LOCATION_CONFIRMATION) {
        this.submitValue[0] = this.HOME;
        this.submitValue[1] = this.TRAVEL;
      } else if (this.type == this.AUTOTRIP) {
        this.submitValue[0] = this.YES;
        this.submitValue[1] = this.NO;
      }

      if (locationConfirmationService.response.location) {
        this.locationInput = locationConfirmationService.response.location;
      }

      if (locationConfirmationService.response.suggestedHomeLocation) {
        this.homeInput = locationConfirmationService.response.suggestedHomeLocation;
      }

      this.url = utils.getApiUrlV2(`trips/${userModel.item.id}/location_popup`);
    } catch(e) {
      // $window.Raven.captureException(e);
    }

    function focusInput(which) {
      try {
        $window.document.getElementById(which).focus();
      } catch(e) {
        //
      }
    }

    $timeout(() => {
      focusInput('location');
    });

    // Submit button on autotrip/location confirmation popup
    this.submit = (submitValue) => {
      this.isSaving = true;
      if (this.type === this.LOCATION_CONFIRMATION) {
        this.confirmLocation(submitValue);
      } else if (this.type === this.AUTOTRIP) {
        this.autoTrip(submitValue);
      }
    };

    this.saveHomeLocation = (placeId) => {
      settings.save('location', placeId, 'placeId').then(() => {
        this.onSuccess();
      }).catch(() => {
        this.isSaving = false;
      }).finally(() => {
        userModel.initItem(userModel.item.id, true).then(() => {
          $timeout(() => {
            $rootScope.$emit('location:update');
          }, NOTIFICATION_DELAY);

        });
      });
    };

    this.confirmLocation = (locationType) => {
      this.saveLocationType(locationType).finally(() => {
        if (locationType === this.HOME) {
          // save home location
          this.saveHomeLocation(this.locationInput.placeId);
        } else {
          // User on a trip
          // save home location via new input
          // switch views
          this.locationView = false;
          this.homeView = true;
          // change placeholder
          this.placeHolder = '';
          // cancel saving
          this.isSaving = false;
          // focus input
          $timeout(() => {
            focusInput('home');
          });
        }
      });
    };

    // should be in service

    this.checkForLocationChange = () => {
      return this.locationInput.placeId !== locationInitialId;
    };

    this.saveLocationType = (locationType) => {
      var postData = {
        action: locationType
      };
      if (locationType === this.TRAVEL) {
        postData.placeId = this.locationInput.placeId;
      }
      if (this.checkForLocationChange()) {
        postData.changedFromPlaceId = locationInitialId;
      }
      return $http.post(this.url, postData);
    };

    this.saveHome = () => {
      this.isSaving = true;
      this.saveHomeLocation(this.homeInput.placeId);
    };

    this.autoTrip = (confirmation) => {
      this.saveTravelResponse(confirmation).then(() => {
        this.onSuccess();
      }).catch(() => {
        this.isSaving = false;
      });
    };

    // TODO: should be in service
    this.saveTravelResponse = (confirmation) => {
      var travelResponse = { action: confirmation, placeId: this.locationInput.placeId};
      if (this.checkForLocationChange()) {
        travelResponse.changedFromPlaceId = locationInitialId;
      }
      return $http.post(this.url, travelResponse);
    };
  },
};



// WEBPACK FOOTER //
// ./app/src/components/location_confirmation/location_confirmation_modal.js